import React from 'react';
import PropTypes from 'prop-types';
import {getFormattedString, getAbsoluteValue} from './Input.utlis';
import {MCStateContext} from '../../../..';

import './style.scss';

export function Input(props) {
  const {running} = React.useContext(MCStateContext);

  const className = `mc_input ${props.className}`;

  const [value, setValue] = React.useState();

  React.useEffect(() => {
    setValue(getFormattedString(props.value));
  }, [props.value]);

  const onChange = (event) => {
    if (!running) {
      const updatedValue = event.target.value;
      let updatedNumber = getAbsoluteValue(updatedValue);
      if (!isNaN(updatedNumber)) {
        let formattedValue = getFormattedString(updatedNumber);
        setValue(formattedValue);
      } else if (updatedValue === '') setValue(undefined);
    }
  };

  const onBlur = () => {
    const currentValue = getAbsoluteValue(value);
    if (currentValue === undefined) props.setValue(0);
    if(value < 1000){
      props.setValue(1000);
      setValue(1000)
    }else{
      props.setValue(currentValue);
    }
  };

  return (
    <input
      className={className}
      tabIndex={props.tabIndex}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      aria-label={props.ariaLabel}
    />
  );
}

Input.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   *  specifies if keyboard accessible or not
   */
  tabIndex: PropTypes.number,
  /**
   * value displayed on input
   */
  value: PropTypes.number,
  /**
   * callback to set value of input text (here used only when loosing focus on input)
   */
  setValue: PropTypes.func,
};

Input.defaultProps = {
  className: '',
  value: 0,
  tabIndex: 0,
};
